import React from "react";
import img1 from "./imgs/01.jpg";
import img2 from "./imgs/02.jpg";
import img3 from "./imgs/03.jpg";
import img4 from "./imgs/04.jpg";
import img5 from "./imgs/05.jpg";
import img6 from "./imgs/06.jpg";
import img7 from "./imgs/07.jpg";
import img8 from "./imgs/13-RPEX6.jpg"
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/01en.jpg";
import img2en from "./imgs/02en.jpg";
import img3en from "./imgs/03en.jpg";
import img4en from "./imgs/04en.jpg";
import img5en from "./imgs/05en.jpg";
import img6en from "./imgs/06en.jpg";
import img7en from "./imgs/07en.jpg";
import img8en from "./imgs/13-RPEX 6.jpg"

export function RPEX6() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img1}/>
                    <img className="product-img" src={img2}/>
                    <img className="product-img" src={img3}/>
                    <img className="product-img" src={img4}/>
                    <img className="product-img" src={img5}/>
                    <img className="product-img" src={img6}/>
                    <img className="product-img" src={img7}/>
                    <img className="product-img" src={img8}/>
                </>
                : <>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                    <img className="product-img" src={img3en}/>
                    <img className="product-img" src={img4en}/>
                    <img className="product-img" src={img5en}/>
                    <img className="product-img" src={img6en}/>
                    <img className="product-img" src={img7en}/>
                    <img className="product-img" src={img8en}/>
                </>
            }
        </>
    )
}
